import PropTypes from 'prop-types';

import BaseLoader from 'core/components/Loader';


function SkeletonLoader(props) {
  const { skeleton: Skeleton = BaseLoader } = props;

  return <Skeleton {...props} />;
}

SkeletonLoader.propTypes = {
  /**
   * Скелетон отрабатывает только если передана кастомная разметка.
   * Без разметки скелетон не имеет смысла и сработает фоллбек на базовый Loader.
   */
  skeleton: PropTypes.func,
};

export { SkeletonLoader };
export default SkeletonLoader;
